import React, { FC } from "react";
import Carousel from "../Carousel/Carousel";

import { ProductCard } from "../ProductCard/ProductCard";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import { Product } from "../../types/product/product.types";
import Link from "../Link/Link";

interface ProductCatalogueProps {
  sectionTitle: string;
  products: Product[];
  sectionId?: string;
}

export const ProductCatalogue: FC<ProductCatalogueProps> = (props) => {
  const allProductsButtonLabel = "All products";

  const handleOnClick = () => window.open("/product-catalogue/", "_self");

  return (
    <section className="pt-24 md:pt-28 z-40 container" id={props.sectionId || undefined}>
      <div className="flex justify-between">
        <SectionHeading colorVariant="primary" title={props.sectionTitle} />

        <Link
          text={allProductsButtonLabel}
          href="/product-catalogue/"
          variant="link-primary"
          className="hidden md:inline-flex max-h-10"
        />
      </div>

      <Carousel>
        {props.products.map((product, index) => (
          <ProductCard key={index} {...product} />
        ))}
      </Carousel>

      <Link
        text={allProductsButtonLabel}
        href="/product-catalogue/"
        variant="secondary"
        className="md:hidden inline-flex max-h-10 w-full mt-10 justify-center"
      />
    </section>
  );
};
